import { CheckBox as BaseCheckBox, FlexColumn, FormModal as BaseFormModal } from '@ubeya/shared-web/components';
import { ReactComponent as ExternalLink } from '@ubeya/shared-web/assets/external-link.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';

const FormModal = styled(BaseFormModal)`
  .submit-button:not(:disabled) {
    background: ${({ theme }) => theme.colors.redNegative} !important;
  }
`;
const Container = styled(FlexColumn)`
  gap: 32px;
`;

const CheckBox = styled(BaseCheckBox)`
  margin-left: -20px;
`;

const LinkLabel = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.link};
  text-decoration: none;
`;

const LinkIcon = styled(ExternalLink)`
  margin-right: 4px;
`;

const READ_MORE_LINK = 'https://learn.ubeya.com/en/';

const EmployeeContractTerminateModal = ({ onClose, terminateEmployeeContract, employeeContractId }) => {
  const { t } = useContext(ConfigContext);
  const [understandConfirm, setUnderstandConfirm] = useState(false);

  const onSubmit = useCallback(async () => {
    await terminateEmployeeContract({
      employeeContractId
    });
    onClose();
  }, [employeeContractId, onClose, terminateEmployeeContract]);

  return (
    <FormModal
      onSubmit={onSubmit}
      size="small"
      onClose={onClose}
      title={t('contractTypes_terminateEmployeeContract')}
      confirmText={t('delete')}
      showCancelButton
      disabledConfirm={!understandConfirm}
      disabledOnPristine={false}>
      <Container>
        <p>{t('contractTypes_terminateConfirmText')}</p>

        <LinkLabel href={READ_MORE_LINK} target="_blank">
          <LinkIcon />
          {t('adminPrivilegesReadMore')}
        </LinkLabel>

        <CheckBox
          name="understandConfirm"
          label={t('contractTypes_terminateConfirmCheckText')}
          value={understandConfirm}
          onChange={setUnderstandConfirm}
        />
      </Container>
    </FormModal>
  );
};

export default EmployeeContractTerminateModal;
